import {
  getTrackerId,
  POSTHOG_CAPTURE_ATTRIBUTES,
  TRACKER_IDS,
} from '../../../config/tracker';
import { isMobile, SIZE_MD, SIZE_SM, SIZE_XS } from '../../../../../hooks/useBreakPoint';
import TCPill, { TC_PILL_TYPE } from '../../TCPill';

import './MarketingSliderSlide.scss';

const {
  dashboard: {
    marketing: {
      slide: trackerSlide,
    },
  },
} = TRACKER_IDS;

export const MARKETING_TYPE = {
  REWARDS: 'rewards',
  CAROUSEL: 'carousel',
};

const MarketingSliderSlide = ({
  index,
  marketingItem,
  onClick,
  trackerProps = {},
}) => {
  const isMobileXsSmMd = isMobile([SIZE_XS, SIZE_SM, SIZE_MD]);

  const {
    marketingType,
    rewardItem,
    carouselItem,
  } = marketingItem;

  const isCarouselType = marketingType === MARKETING_TYPE.CAROUSEL;

  const handleOnClick = () => onClick?.(marketingItem);

  return (
    <button
      className="MarketingSliderSlide"
      onClick={handleOnClick}
      type="button"
      aria-label="marketing slide"
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          handleOnClick();
        }
      }}
      {...{
        [POSTHOG_CAPTURE_ATTRIBUTES.TRACKER_ID]: getTrackerId(trackerSlide),
        ...(!Number.isNaN(index) && {
          [POSTHOG_CAPTURE_ATTRIBUTES.LIST_POSITION]: Number(index) + 1,
        }),
        ...(isCarouselType ? {
          [POSTHOG_CAPTURE_ATTRIBUTES.ACTION_ID]: carouselItem.posthogId,
        } : {
          [POSTHOG_CAPTURE_ATTRIBUTES.REWARD_ID]: rewardItem.uid,
          [POSTHOG_CAPTURE_ATTRIBUTES.REWARD_NAME]: rewardItem.name,
        }),
        ...trackerProps,
      }}
    >
      <div
        className="MarketingSliderSlide__container"
        alt="reward image"
        style={isCarouselType ? {
          backgroundImage: `url(${(isMobileXsSmMd && carouselItem.mobileImageUrl) || carouselItem.desktopImageUrl})`,
        } : {
          background: `linear-gradient(rgba(0, 0, 0, 0.15) 0%, rgba(0, 0, 0, 0.55) 100%), url(${rewardItem.store?.imgUrl}) lightgray 50% / cover no-repeat`,
        }}
      >
        {!isCarouselType && (
          <>
            {rewardItem.allowTcCredits && Number(rewardItem.store?.tcCreditAmount) > 0 && (
              <div className="MarketingSliderSlide__container-pill">
                <TCPill
                  balance={Number(rewardItem.store.tcCreditAmount)}
                  type={TC_PILL_TYPE.EARN}
                  amountType={rewardItem.store?.tcCreditAmountType}
                />
              </div>
            )}
            <div className="MarketingSliderSlide__container-content">
              <div className="MarketingSliderSlide__container-content-image">
                <img
                  className="MarketingSliderSlide__container-content-image-logo"
                  src={rewardItem.store?.logoUrl}
                  alt="reward logo"
                />
              </div>
              <p className="MarketingSliderSlide__container-content-description">
                {rewardItem.description}
              </p>
              <span className="MarketingSliderSlide__container-content-cta">
                SHOP NOW
              </span>
            </div>
          </>
        )}
      </div>
    </button>
  );
};

export default MarketingSliderSlide;
